import data from "../../.sourceflow/awards.json";
import BaseCollection from "@sourceflow-uk/sourceflow-sdk/base_collection";

export const getAwards = (locale = "en") => {
  return new BaseCollection(data, locale).orderBy((i) => parseInt(i["_order"])).getItems();
};
